import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import PayNow from './pages/Company/PayNow/PayNow';
import Radix from './pages/Products/Radix/Radix';
import BlogPage from './pages/Blog/BlogPage';
import BlogPost from './pages/Blog/BlogPost/BlogPost'; 
import Header from './components/Header';
import Footer from './components/Footer';

const App = () => {
  return (
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/paynow" element={<PayNow />} />
        <Route path='/radix' element={<Radix />} />
        <Route path='/blog' element={<BlogPage />} />
        <Route path='/blog/:id' element={<BlogPost />} /> 
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
